import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Chip,
  Fade,
} from "@mui/material";
import {
  AttachFile,
  Delete,
  Warning,
  LocalShipping,
  CheckCircle,
} from "@mui/icons-material";
import MaterialReactTable from "material-react-table";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { UrlApi } from "../../../../services/apirest";
import Modalquitarpedido from "./Modalquitarpedido";
import DialogEntregado from "../../../referencias-tablas/pedidos/DialogEntregado";
import Notify from "../../../Notify";
import moment from "moment";
// import FileUploadViajes from "./FileUploadViajes";
import UploadFiles2 from "../../../../services/UploadFiles2";
import DetalleReclamo from "./DetalleReclamo";
import MapaRepartos from "../MapaRepartos";

export default function VerDatosRep(props) {
  const [datos, setDatos] = useState(props.datos);
  const [detallesViaje, setDetallesViaje] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estados originales que faltaban
  const [openPedidos, setopenPedidos] = useState(false);
  const [eliminarPedido, seteliminarPedidos] = useState(false);
  const [datosPedidos, setDatosPedidos] = useState({});

  // Estados para adjuntos
  const [openCloseAdj, setOpenCloseAdj] = useState(false);
  const [newUuid, setNewUuid] = useState(null);

  // Estados para diálogos y notificaciones
  const [openDialogEliminar, setOpenDialogEliminar] = useState(false);
  const [reclamoAEliminar, setReclamoAEliminar] = useState(null);
  const [eliminando, setEliminando] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  // --- ESTADOS PARA EL BADGE CON ANIMACIÓN ---
  const [deletionMessage, setDeletionMessage] = useState("");
  const [showDeletionBadge, setShowDeletionBadge] = useState(false);
  const deletionTimerRef = useRef(null);

  // Limpiar timer al desmontar
  useEffect(() => {
    return () => {
      if (deletionTimerRef.current) {
        clearTimeout(deletionTimerRef.current);
      }
    };
  }, []);

  // Función para mostrar el badge con fade in/out
  const showDeletionSuccess = (message) => {
    if (deletionTimerRef.current) {
      clearTimeout(deletionTimerRef.current);
    }
    setDeletionMessage(message);
    setShowDeletionBadge(true);
    // Ocultar después de 4 segundos
    deletionTimerRef.current = setTimeout(() => {
      setShowDeletionBadge(false);
    }, 4000);
  };
  // --------------------------------------------

  // Función para manejar adjuntos
  const handleOpenCloseAdj = (value, uuid = null) => {
    setNewUuid(uuid);
    setOpenCloseAdj(value);
  };

  // Función para cerrar notificación
  const handleCloseNotificacion = () => {
    setNotificacion({
      ...notificacion,
      open: false,
    });
  };

  // VER MAPA ----------------------------
  const [openMapa, setOpenMapa] = useState(false);
  const [datosMapa, setDatosMapa] = useState(null);

  const handleUbicacion = (reclamo) => {
    setDatosMapa(reclamo);
    setOpenMapa(true);
  };

  // -----------------------------------------

  const obtenerDetallesViaje = (uuid_viaje) => {
    const uuid = uuid_viaje || datos.uuid_viaje;

    if (!uuid) {
      console.error("No hay UUID de viaje disponible");
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(UrlApi + "/viajes_gruas/detalles/viaje/" + uuid)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setDetallesViaje(data);
        } else {
          console.error("La API no devolvió un array:", data);
          setDetallesViaje([]);
        }
      })
      .catch((error) => {
        console.error("Error obteniendo detalles del viaje:", error);
        setDetallesViaje([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (datos && datos.uuid_viaje) {
      obtenerDetallesViaje(datos.uuid_viaje);
    } else {
      setLoading(false);
    }
  }, [datos?.uuid_viaje]);

  const handleEliminarClick = (reclamo) => {
    setReclamoAEliminar(reclamo);
    setOpenDialogEliminar(true);
  };

  const confirmarEliminacion = () => {
    if (!reclamoAEliminar) return;

    setEliminando(true);

    const uuid_viaje = datos.uuid_viaje;
    const esUltimoReclamo = detallesViaje.length === 1; // Solo este reclamo en el viaje

    const datosActualizacion = {
      estado: 346,
      uuid_viaje: null,
      estado_viaje: null,
    };

    // 1. Actualizar el reclamo (quitarlo del viaje)
    fetch(`${UrlApi}/reclamos/update_2/${reclamoAEliminar.id_reclamo}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datosActualizacion),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Error al actualizar reclamo: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        // 2. Si era el último reclamo, eliminar el viaje_grua
        if (esUltimoReclamo) {
          return fetch(`${UrlApi}/viajes_gruas/por_uuid/${uuid_viaje}`, {
            method: "DELETE",
          }).then((res) => {
            if (!res.ok) {
              throw new Error(`Error al eliminar el viaje: ${res.status}`);
            }
            return res.json();
          });
        }
      })
      .then((viajeEliminadoData) => {
        setOpenDialogEliminar(false);
        setReclamoAEliminar(null);

        if (esUltimoReclamo) {
          // No mostrar badge local, notificar al padre
          if (props.onViajeEliminado) {
            props.onViajeEliminado(uuid_viaje);
          } else {
            setDetallesViaje([]);
          }
        } else {
          showDeletionSuccess(
            `Reclamo #${reclamoAEliminar.id_reclamo} eliminado del viaje`,
          );
          obtenerDetallesViaje(datos.uuid_viaje);
        }
      })
      .catch((error) => {
        console.error("Error en el proceso de eliminación:", error);
        setNotificacion({
          open: true,
          mensaje: `Error: ${error.message}`,
          severity: "error",
          color: "red",
        });
        // Si falló, cierra el diálogo pero no actualiza la lista
        setOpenDialogEliminar(false);
        setReclamoAEliminar(null);
      })
      .finally(() => {
        setEliminando(false);
      });
  };

  const cancelarEliminacion = () => {
    setOpenDialogEliminar(false);
    setReclamoAEliminar(null);
  };

  const getEstadoViajeColor = (estadoViaje) => {
    switch (estadoViaje) {
      case "Asignado":
        return { bg: "#1976D2", color: "white" };
      case "Iniciado":
        return { bg: "#2196F3", color: "white" };
      case "Finalizado":
        return { bg: "#2E7D32", color: "white" };
      case "Cancelado":
        return { bg: "#D32F2F", color: "white" };
      default:
        return { bg: "#757575", color: "white" };
    }
  };

  // Función para obtener el color de la fila según el estado
  const getRowColorByEstado = (idEstado) => {
    switch (idEstado) {
      case 343: // Asignado
        return {
          bgColor: "#F0F7FF",
          hoverColor: "#E1F0FF",
        };
      case 345: // Finalizado
        return {
          bgColor: "#F0FFF4",
          hoverColor: "#E1F7E8",
        };
      case 353: // Cancelado
        return {
          bgColor: "#FFF0F0",
          hoverColor: "#FFE1E1",
        };
      default:
        return {
          bgColor: null,
          hoverColor: "#F5F5F5",
        };
    }
  };

  const formatFecha = (fechaString) => {
    if (!fechaString) return "-";
    return moment(fechaString).format("DD/MM/YYYY");
  };

  // --------------------------------------------------

  const columns = [
    {
      accessorKey: "id_reclamo",
      header: "ID",
      size: 80,
      Cell: ({ cell }) => (
        <Typography variant="body2" fontWeight="bold" align="center">
          #{cell.getValue()}
        </Typography>
      ),
    },
    {
      accessorKey: "cliente_razon_social",
      header: "Cliente",
      size: 200,
      Cell: ({ cell }) => (
        <Typography variant="body2" noWrap title={cell.getValue()}>
          {cell.getValue()}
        </Typography>
      ),
    },
    {
      accessorKey: "direccion_entrega",
      header: "Dirección",
      size: 250,
      Cell: ({ cell }) => (
        <Box
          sx={{
            maxHeight: "60px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
            {cell.getValue()}
          </Typography>
        </Box>
      ),
    },
    {
      accessorKey: "localidad",
      header: "Localidad",
      size: 120,
      Cell: ({ cell }) => (
        <Typography variant="body2">{cell.getValue()}</Typography>
      ),
    },
    {
      accessorKey: "nro_remito",
      header: "Remito",
      size: 120,
      Cell: ({ cell }) => (
        <Typography variant="body2" align="center">
          {cell.getValue() || "-"}
        </Typography>
      ),
    },
    {
      accessorKey: "fecha_finalizacion_viaje",
      header: "Fin Viaje",
      size: 120,
      Cell: ({ cell }) => (
        <Typography variant="body2">{formatFecha(cell.getValue())}</Typography>
      ),
    },
  ];

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={200}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Cargando reclamos...
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {detallesViaje.length > 0 ? (
        <MaterialReactTable
          columns={columns}
          data={detallesViaje}
          enableRowActions
          positionActionsColumn="last"
          enablePagination={false}
          enableSorting={false}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          enableHiding={false}
          enableGlobalFilter={false}
          enableFilters={false}
          enableStickyHeader
          initialState={{ density: "compact" }}
          localization={MRT_Localization_ES}
          muiTableBodyRowProps={({ row }) => {
            const reclamo = row.original;
            const colors = getRowColorByEstado(reclamo.id_estado_viaje);
            return {
              sx: {
                backgroundColor: colors.bgColor,
                "&:hover": {
                  backgroundColor: colors.hoverColor,
                },
              },
            };
          }}
          // --- TÍTULO CON BADGE A LA DERECHA ---
          renderTopToolbarCustomActions={() => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                pr: 2,
              }}
            >
              {/* Título a la izquierda */}
              <Box sx={{ p: 1 }}>
                {datos?.nro_transito ? (
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <LocalShipping color="primary" />
                    Tránsito: {datos.nro_transito}
                  </Typography>
                ) : (
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <LocalShipping color="primary" />
                    Reclamos del Viaje
                  </Typography>
                )}
              </Box>

              {/* Badge animado con Fade */}
              <Fade
                in={showDeletionBadge}
                timeout={300}
                unmountOnExit
                onExited={() => setDeletionMessage("")}
              >
                <Chip
                  icon={<CheckCircle />}
                  label={deletionMessage}
                  color="success"
                  variant="filled"
                  size="small"
                  sx={{
                    fontWeight: 500,
                    "& .MuiChip-icon": { color: "white" },
                  }}
                />
              </Fade>
            </Box>
          )}
          renderRowActions={({ row }) => {
            const reclamo = row.original;
            const isFinalizado = reclamo.id_estado_viaje === 345;

            return (
              <Box display="flex" gap={0.5}>
                <Tooltip title="Ver ubicación">
                  <IconButton
                    size="small"
                    color="warning"
                    onClick={() => handleUbicacion(reclamo)}
                  >
                    <PersonPinCircleIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Ver adjuntos">
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => {
                      handleOpenCloseAdj(true, reclamo.uuid);
                    }}
                  >
                    <AttachFile fontSize="small" />
                  </IconButton>
                </Tooltip>
                {!isFinalizado &&
                  Number(localStorage.getItem("sector")) === 12 && (
                    <Tooltip title="Eliminar del viaje">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleEliminarClick(reclamo)}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
              </Box>
            );
          }}
          renderDetailPanel={({ row }) => (
            <DetalleReclamo
              row={row}
              getEstadoViajeColor={getEstadoViajeColor}
              getRowColorByEstado={getRowColorByEstado}
              formatFecha={formatFecha}
            />
          )}
          muiTableContainerProps={{
            sx: {
              maxHeight: "500px",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
            },
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              border: "none",
              backgroundColor: "transparent",
            },
          }}
          muiDetailPanelProps={{
            sx: {
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
            },
          }}
          muiTableHeadRowProps={{
            sx: {
              backgroundColor: "#f5f5f5",
            },
          }}
        />
      ) : (
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: "center",
            backgroundColor: "#fafafa",
            borderRadius: 2,
            border: "1px dashed #e0e0e0",
          }}
        >
          <Typography variant="body1" color="textSecondary">
            No hay reclamos para este viaje
          </Typography>
        </Paper>
      )}

      {/* Diálogo de eliminación */}
      <Dialog
        open={openDialogEliminar}
        onClose={cancelarEliminacion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Warning color="error" />
          Confirmar eliminación
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {reclamoAEliminar && (
              <>
                <Box
                  sx={{
                    mb: 2,
                    p: 1.5,
                    backgroundColor: "#fff3e0",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="body2">
                    • <strong>Reclamo #{reclamoAEliminar.id_reclamo}</strong>
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Cliente:</strong>{" "}
                    {reclamoAEliminar.cliente_razon_social}
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Detalle:</strong> {reclamoAEliminar.detalle}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mt: 2, fontStyle: "italic" }}>
                  Esta acción removerá el reclamo del viaje actual, pero el
                  reclamo permanecerá en el sistema.
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    ¿Desea eliminar el reclamo del viaje?
                  </Typography>
                </Box>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
            pb: 2,
          }}
        >
          <Button
            onClick={cancelarEliminacion}
            disabled={eliminando}
            variant="outlined"
          >
            Volver
          </Button>
          <Button
            onClick={confirmarEliminacion}
            disabled={eliminando}
            variant="contained"
            color="error"
            autoFocus
            startIcon={
              eliminando ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Delete />
              )
            }
          >
            {eliminando ? "Eliminando..." : "Eliminar"}
          </Button>
        </DialogActions>
      </Dialog>

      {openPedidos && (
        <DialogEntregado
          pedido={datosPedidos}
          open={openPedidos}
          setOpen={setopenPedidos}
          actualizar={obtenerDetallesViaje}
        />
      )}

      {eliminarPedido && (
        <Modalquitarpedido
          actualizar={obtenerDetallesViaje}
          datos={datosPedidos}
          open={seteliminarPedidos}
        />
      )}

      {/* Notify solo para errores y otros casos */}
      {notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleCloseNotificacion}
          severity={notificacion.severity}
        />
      )}

      {openMapa && datosMapa && (
        <Dialog
          open={openMapa}
          onClose={() => setOpenMapa(false)}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              borderRadius: 4,
            },
          }}
        >
          <DialogContent>
            <MapaRepartos
              latitud={datosMapa.latitud}
              longitud={datosMapa.longitud}
              direccion_entrega={datosMapa.direccion_entrega}
              handleClose={() => setOpenMapa(false)}
            />
          </DialogContent>
        </Dialog>
      )}

      {openCloseAdj && (
        <UploadFiles2
          fileId={newUuid}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)}
        />
      )}
    </Box>
  );
}
